'use client'

import { useState } from 'react'
import { Box } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'
import Link from 'next/link'

import { getCategoryName, getCategoryURL } from 'components/nav/CategoriesMenu/utils/categories'
import { CategoryCard } from 'components/ui/Card/CategoryCard'

import { CategoriesWrapper } from './styles'

type Props = {
  categories: ProductCategory[]
}

const HeroCategoryBox = ({ categories }: Props): JSX.Element => {
  const [selectedCategory, setSelectedCategory] = useState<number | undefined>(undefined)

  return (
    <CategoriesWrapper>
      {categories.map((category) => (
        <Box key={category.id} onClick={() => setSelectedCategory(category.id)} className="gtm-category-card">
          <Link href={getCategoryURL(category, categories)} legacyBehavior>
            <a className="gtm-category-link">
              <CategoryCard
                isCategorySelected={selectedCategory === category.id}
                category={{
                  id: category.id,
                  name: getCategoryName(category),
                  url: category.imageUrl,
                }}
              />
            </a>
          </Link>
        </Box>
      ))}
    </CategoriesWrapper>
  )
}

export default HeroCategoryBox
